const PER_PAGE = 9;
let page = 0;

// careers archvive block with filters + pagination
export const codeCareers = () => {
  // hide pagination button when all unfiltered posts are visible
  const togglePaginationVisibility = () => {
    const hasMorePosts =
      $('.code-careers .wp-block-post.hidden:not(.filtered)').length > 0;

    $('.code-careers .posts-pagination').toggleClass('hidden', !hasMorePosts);
  };

  // on filter select, hide posts
  $('.code-careers .select').on('change', function () {
    const type = $(this).val();

    // update state
    page = 0;

    // all posts
    const $items = $('.code-careers__grid > ul').children();

    if (type === 'all') {
      $items.removeClass('filtered');
    } else {
      // add filtered class to hide items
      $items.each((_, el) => {
        $(el).toggleClass('filtered', el.getAttribute('data-type') !== type);
      });
    }

    // paginate unfiltered posts
    const $unfilteredItems = $('.code-careers .wp-block-post:not(.filtered)');
    $unfilteredItems.slice(0, PER_PAGE).removeClass('hidden');
    $unfilteredItems.slice(PER_PAGE).addClass('hidden');

    togglePaginationVisibility();
  });

  // on view more click, show next posts up to the per page limit
  $('.code-careers .posts-pagination > .button').on('click', function () {
    $('.code-careers .wp-block-post.hidden:not(.filtered)')
      .slice(0, PER_PAGE)
      .removeClass('hidden');

    togglePaginationVisibility();
    page++;
  });
};
